import { TickMarkThinIcon } from '@sketchnote/icons';
import classNames from 'classnames';
import * as React from 'react';

export interface SidebarTabProps {
  onCloseBtnClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  isActive: (arg: string) => boolean;
  menuItems?: {
    sectionTitle?: string;
    items: { label: string | JSX.Element; value: string; icon?: JSX.Element }[];
  }[];
  headText?: string;
  handleMenuClick?: (value: string) => void;
  width?: string;
  children: HTMLElement | JSX.Element;
  height?: string;
}

export const SidebarTab = ({
  children,
  menuItems,
  headText,
  handleMenuClick,
  isActive,
  height,
}: SidebarTabProps): JSX.Element => {
  return (
    <div className="flex bg-white" style={{ height: `${height}` }}>
      <div
        style={{ width: '248px' }}
        className="px-20 py-24 rounded-l-lg border-r border-gray-200 "
      >
        <h3 className=" font-regular leading-32 text-xs mb-8">{headText}</h3>
        <nav className="flex flex-col">
          {menuItems?.map(({ sectionTitle, items }, index) => (
            <React.Fragment key={`${sectionTitle}-${index}`}>
              {sectionTitle && (
                <span className="text-xs mb-18 mt-16 font-medium text-gray-500">
                  {sectionTitle}
                </span>
              )}
              {items?.map(({ label, value }, index) => (
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key}
                  key={`${value}-${index}`}
                  className={classNames({
                    'flex items-center gap-8 px-8 py-7 rounded-sm min-w-btn-lg hover:bg-gray-100 cursor-pointer align-middle text-sm':
                      true,
                    'text-black font-medium': isActive(value),
                    'text-gray-600 font-thin': !isActive(value),
                  })}
                  onClick={handleMenuClick?.bind(this, value)}
                >
                  <TickMarkThinIcon
                    size={20}
                    className={classNames({
                      'opacity-0': !isActive(value),
                    })}
                  />
                  {label}
                </div>
              ))}
            </React.Fragment>
          ))}
        </nav>
      </div>

      <div className="bg-white overflow-y-scroll flex-grow min-w-0 mt-32">{children}</div>
    </div>
  );
};
